import { useDeskById } from "@hooks/inventory/roomConfiguration/desk/useDeskDetails";
import { DeskForm, DeskListTable } from "./component";

interface DeskProps {
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  setErrorMessage: (err: string) => void;
  handleScrollToTop: () => void;
}

export default function Desk({
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  setErrorMessage,
  handleScrollToTop,
}: DeskProps) {
  const { handleQueryById, deskState, updateDeskHandler, createDeskHandler } =
    useDeskById(false);

  return (
    <div>
      <DeskForm
        setIsErrorModalOpen={setIsErrorModalOpen}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        setErrorMessage={setErrorMessage}
        deskState={deskState}
        updateDeskHandler={updateDeskHandler}
        createDeskHandler={createDeskHandler}
      />
      <DeskListTable
        handleQueryById={handleQueryById}
        handleScrollToTop={handleScrollToTop}
      />
    </div>
  );
}
